
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`Jest to zasługą projektu Folksonomy Engine
                    <a href="${0}"></a>. Nie wahaj się
                    wziąć udziału lub podzielić się swoją opinią`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`To narzędzie pozwala na poprawienie listy składników. Możesz dodać, usunąć lub edytować listę składników
                .
                <br>
                Ten znak <span class="highlight">␣</span> reprezentuje spację.
                <br>
                Ten znak <span class="highlight">↩︎</span> reprezentuje podział wiersza. `,
'hb28f1f2ec1744ee9': html`Te właściwości są tworzone i zapisywane przez użytkowników do dowolnego zastosowania. Możesz
                    dodać własne. Tworzone właściwości i wartości
                    <strong>muszą być oparte na faktach</strong>. Możesz zapoznać się z
                    <a href="${0}">listą właściwości już używanych przez społeczność</a>
                    lub przejrzeć dokumentację właściwości
                    <a href="${1}">i ich wyszukiwarkę</a>.`,
's000a5b76bd3a01c2': `Ładowanie właściwości...`,
's000d98595e959c1e': `Dostępny w Google Play`,
's013bdc8cf0d3583d': `Pomóż nam w znalezieniu składników`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `Sprawdź uprawę`,
's03e9c8114521b998': `Edytuję składniki`,
's05ec315d9308091a': `Ikona narożników kodu kreskowego`,
's061eb5af92512c85': `Zapisane! Czy możesz pomóc z innym?`,
's06847c221c4c0bc1': `Chciałbym utworzyć właściwość, która [opisz swój przypadek użycia]...`,
's06f6c6f99db6b552': `Oryginalny`,
's081e2ad82db71e1d': `Wartości zgrupowane`,
's09205907b5b56cda': `Nie`,
's0b4235aae602a950': `dedykowana dokumentacja`,
's0bb2d48532acc455': `Pobierz plik CSV`,
's0d5b7fee0311db68': `Właściwość`,
's0fb218abc2e157ed': `Unieważnij obraz`,
's100c4928cc74642a': `wspierają rozwój badań nad zdrowiem publicznym.`,
's10db5498186c083b': `Anuluj przycinanie`,
's11a18a69b30b65ed': `Pomóż nam naprawić błędy na liście składników`,
's1205d5f6fccf8e69': `Wartość nieruchomości`,
's15d64a0a6715285a': `Nowy klucz`,
's166bd56d19670a72': `Powiększenie`,
's19059bf0c4f7c162': `Obszar wyboru`,
's1a52515ec8ddade8': `Kod kreskowy produktu`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `Pomóż nam poprawić informacje żywieniowe`,
's1e00019dc454872d': `Proszę podać nazwę właściwości korzystając z atrybutu property-name.`,
's1e49126af0935a5b': `Lista produktów korzystających z tej właściwości`,
's21e73088de6f26f3': `Dostępny w Google Play`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Anuluj`,
's2db7b654c0a9bde0': `Udokumentuj nieruchomość`,
's300b3a6ee4e1252d': str`Słabe dopasowanie ${0}%`,
's33f786bb6b4f0cf4': `Wynik przycinania`,
's33f85f24c0f5f008': `Zapisz`,
's34be4af4e8fec4ae': `Najpierw zapytaj społeczność`,
's36d86adc823cbfa6': `Przed utworzeniem nowej nieruchomości omów ją ze społecznością:`,
's3781d25aa51a736c': `Dokumentacja silnika Folksonomy`,
's383ae4449428b61e': `Zresetuj przycinanie`,
's39bcf88721a1e8ee': `Zresetuj wybór`,
's39e14e14300694c7': `Dokumentacja i wytyczne`,
's3b430cfa5c1fe7f4': str`Dokumentacja dla ${0}`,
's3f4e4b52f230a892': `Płótno obrazu`,
's417b90913e05bc17': `Zapowiedź`,
's41f7dca46d3f1b4a': `Wartość`,
's422bba9636ce2489': `Obraz środkowy`,
's42dd66b2441566fd': `Ikona środka`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Dodaj składnik odżywczy`,
's453ab0dbb9b5c777': `Zmień rozmiar w prawo`,
's475b08749d0706ed': `Pomóż nam informować miliony konsumentów na całym świecie o tym, co jedzą`,
's49730f3d5751a433': `Ładowanie...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `Liczba produktów`,
's4df2f533c0c1e7d0': `Kontrolki obrazu`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `Przesuń wybór`,
's4f751fb9b3ed766c': `Tworzenie nowej właściwości`,
's547c12ae169d00bc': `Dostępne na F-Droid`,
's5560fb119e40923d': `Wprowadź nazwę nieruchomości...`,
's55d7249883a98ca1': `o tej nieruchomości na wiki Open Food Facts`,
's565867d84c04aea2': `Właściwości filtra...`,
's5666afe5cd0166de': `Przed potwierdzeniem popraw błędy lub zmodyfikuj tekst`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `Ładowanie produktów...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `Pomóż nam poprawić informacje żywieniowe.`,
's5dd6f12783fca34f': `Edytuj listę składników`,
's5e8250fb85d64c23': `Zamknij`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `WSPIERAM`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Edytuj`,
's66413c24dcf680e2': `Pomiń`,
's67ae6594857a4d57': `Dzięki za twój wkład!`,
's6cee7cad81dfedd1': `Przycięty obraz`,
's6d7b6cdedaadfb6e': `Każda darowizna się liczy! Doceniamy twoje wsparcie w zapewnianiu większej przejrzystości żywności na świecie.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Dobre dopasowanie ${0}%`,
's71a5c9f4b68ef4d4': `Licznik`,
's74cb3d66f6a668e1': `Dokumentacja`,
's787dd11bed0dc88a': `Zmień rozmiar w lewo`,
's7ce4fd9430e80cea': `wartość`,
's801a05fa8e881f37': `Dowiedz się więcej o tworzeniu nieruchomości i wytycznych:`,
's8038273de2cf8b73': `Proszę wybrać region do przycięcia.`,
's839cc2908a5387f2': `Filtruj kody kreskowe...`,
's86197dcf3e96af64': `Przeglądaj i przeszukuj istniejące nieruchomości`,
's8a63be30a129a59c': `Zmień rozmiar dołu`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Zmień rozmiar prawego górnego rogu`,
's8db84aa4bc949af2': `Udokumentuj nową nieruchomość`,
's8f839a03997a16d7': `Zobacz produkt`,
's901ae1e236ac45d3': `Anuluj usunięcie`,
's907f7a97c6b29425': `Należy pamiętać, że model danych może zostać zmodyfikowany. Używaj na własne ryzyko.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `Składniki :`,
's9a7f60fce090ecaf': `Nie udało się załadować właściwości. Spróbuj ponownie później.`,
's9b87abd68fb9df45': `Nie znaleziono? Utwórz nowy klucz {value}`,
's9c0f52425fd2f07e': `Może nie pasować`,
's9fc41f789c63b40d': `Produkty`,
'sa1fa766e0d5634d7': `Brak dostępnego wyniku`,
'sa548778b24054030': `Przeglądaj wszystkie udostępnione właściwości z projektu Folksonomy Engine. Właściwości te dostarczają dodatkowych metadanych i informacji o produktach w bazie danych Open Food Facts.`,
'sa63907958bd0ec4b': `Zmień rozmiar lewego górnego rogu`,
'sa95b4224f685a36a': `Zamknij okno modalne`,
'sab56a1d439576fd6': `Ikona sugestii`,
'sac47ea2901d04c15': `Zmień rozmiar lewego dolnego rogu`,
'sb125227d436c2925': `Wyszukaj koncepcję nieruchomości w istniejącej bazie danych nieruchomości:`,
'sb125568d43642e6f': `Odpowiedz na pytania dotyczące produktu.`,
'sb1c538e038f9b214': str`Bardzo dobre dopasowanie ${0}%`,
'sb28639570ff3b852': `lista wszystkich nieruchomości`,
'sb3bdd638a58d30f4': `angażują społeczność oddanych obywateli,`,
'sb3cbcc1bd0fff140': `Gdy już sprawdzisz, że Twoja własność nie istnieje i społeczność uzna ją za przydatną, musisz ją najpierw udokumentować w wiki.`,
'sb3d4f79d9d8b71e5': `Prześlij`,
'sb560fa37a7bfb6c2': `Nie znaleziono produktów dla tej nieruchomości.`,
'sb7f72e4c8a2d3357': `Wartości filtra...`,
'sb8178320160f84ea': `Pokaż plon`,
'sbad7d2734149470b': `Zweryfikuj`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `Na wszystkie spostrzeżenia udzielono odpowiedzi! Dzięki za pomoc!`,
'sbd9a0b2293b3cd3c': `Wielkość porcji`,
'sbe472dc3c2685985': `Wartość odpowiadająca`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Zmień rozmiar góry`,
'sc1c08d0cbcc3bd24': `Nie pasuje`,
'sc52696641af72b53': `Zainstaluj aplikację!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `Proponowana poprawka`,
'sc681b137e8f604f7': `Potwierdź usunięcie`,
'sc6daf8a31883f8b9': `Przesuń obraz`,
'sc895972c88d38ca5': `Własność folksonomii`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `Wydziwianie`,
'scb3b0671d7b7f640': `Nowa wartość`,
'scb489a1a173ac3f0': `Tak`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Dołącz do dyskusji na Slacku`,
'scdb6cad0b92721bf': `Nie znaleziono żadnych nieruchomości.`,
'scf23a05631f93732': `Potwierdź usunięcie`,
'scfed2f270ef6a3aa': `Wybierz obszar`,
'sd1022bc1ef9204f7': `Obraz powiększalny`,
'sd1077c055cf9ba6b': `Pomóż nam zweryfikować listę składników produktu.`,
'sd698d21ddecba56b': `Hej! Możesz pomóc nam ulepszyć informacje o produkcie, odpowiadając na następujące pytania:`,
'sd82bc2decefa621b': `pozostają niezależne od przemysłu spożywczego,`,
'sdb97e5976482606e': `Sprawdź, czy nieruchomość już istnieje`,
'sdbf806fefc584115': `Powinieneś znaleźć`,
'sdc673e73b5c13aea': `Usuń`,
'sdc792b75f1edcaba': `Pomóż nam poprawić pisownię składników.`,
'sdca5deead576ceee': `Zmień rozmiar prawego dolnego rogu`,
'sdcc2555c5dde524f': `Czy na pewno chcesz usunąć ten element? Tej czynności nie można cofnąć.`,
'se206feec7ec57b28': `w 100 g`,
'se419a9ab36987490': `Unieważnić`,
'se5127cf0f92e7e48': `Wskazówka: możesz również znaleźć`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `Zaproponuję lepszy plon`,
'seea3800e27baa686': `Produkty indywidualne`,
'sefaba4adc4ec9219': `Właściwości folksonomii`,
'seffa8ca49175b5f0': `Nieruchomości spersonalizowane`,
'sf44a6b3b232c28ea': str`Zastąp bieżącą wartość przez ${0}`,
'sf4cd86a2f5ef2588': `Kod kreskowy produktu`,
'sf57a61152168cc81': `Pomóż nam poprawić wykrywanie składników`,
'sf88b90b8ba23871c': `Nieznany mecz`,
'sf9aee319a006c9b4': `Dodaj`,
'sfacbbe968fa7d773': `Nazwa nieruchomości:`,
'sfc40ea3d5d5aa6f8': `Twoje datki finansują codzienną działalność naszej organizacji non-profit:`,
'sfe87465d50530725': `Wartość odpowiadająca`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  